// Shared background treatment for the website's two hero slice types
// (home_hero, secondaryhero) — reproduces .hero-gradient + .floating-orb from
// antaia-website src/index.css exactly (radial washes, blur-3xl orbs, grid overlay).
export const HERO_BG = "#0E3137";
export const ACCENT = "#A6F334";

// .hero-gradient — three stacked radial washes, index.css:93-97
const HERO_GRADIENT_BG = [
  `radial-gradient(ellipse 80% 50% at 50% -20%, ${ACCENT}26, transparent)`,
  `radial-gradient(ellipse 60% 40% at 80% 50%, ${ACCENT}1A, transparent)`,
  `radial-gradient(ellipse 50% 30% at 20% 60%, ${ACCENT}14, transparent)`,
].join(", ");

// Subtle grid-line texture layered on top (same .hero-gradient section)
const GRID_PATTERN_BG =
  "linear-gradient(rgba(255,255,255,0.06) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,0.06) 1px, transparent 1px)";

export const heroGradientBoxProps = {
  position: "relative",
  overflow: "hidden",
  bg: HERO_BG,
  backgroundImage: `${HERO_GRADIENT_BG}, ${GRID_PATTERN_BG}`,
  backgroundSize: "auto, auto, auto, 60px 60px",
};

// .floating-orb — blur-3xl (64px) + opacity-20, index.css:99-101
const ORB_STYLE = { position: "absolute", borderRadius: "full", filter: "blur(64px)", opacity: 0.2 };

// Non-"left" HomeHero orientation orb layout (index.tsx:139-141)
export const HOME_HERO_ORBS = [
  { ...ORB_STYLE, w: "384px", h: "384px", bg: ACCENT, top: "-80px", left: "-80px" },
  { ...ORB_STYLE, w: "320px", h: "320px", bg: ACCENT, top: "50%", right: "-80px", transform: "translateY(-50%)" },
  { ...ORB_STYLE, w: "256px", h: "256px", bg: ACCENT, bottom: "80px", left: "25%" },
];

// Secondaryhero orb layout (Secondaryhero/index.tsx:30-31)
export const SECONDARYHERO_ORBS = [
  { ...ORB_STYLE, w: "320px", h: "320px", bg: ACCENT, top: "-40px", right: "25%" },
  { ...ORB_STYLE, w: "256px", h: "256px", bg: ACCENT, top: "50%", right: "-40px", transform: "translateY(-50%)" },
];
